import React from "react";
import { Button, Typography, Box } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import VisuallyHiddenInput from "../VisuallyHiddenInput";

const MasterFileUpload = ({
	fileType,
	videoPreview,
	pdfPreview,
	audioPreview,
	handleRemoveContentFile,
	handleContentFileChange,
	formik,
}) => {
	return (
		<Box>
			{fileType === "video" && videoPreview ? (
				<div>
					<h3>Uploaded Master File</h3>
					<div
						style={{
							position: "relative",

							marginBottom: "10px",
						}}
					>
						<video
							style={{ width: "100%" }}
							controls
							src={videoPreview}
						></video>
						<button
							onClick={(e) =>
								handleRemoveContentFile(e, "master")
							}
							style={{
								position: "absolute",
								top: "5px",
								right: "5px",
								border: "none",
								backgroundColor: "rgba(255,0,0,0.6)",
								borderRadius: "50%",
								cursor: "pointer",
							}}
						>
							<DeleteIcon style={{ color: "white" }} />
						</button>
					</div>
				</div>
			) : fileType === "pdf" && pdfPreview ? (
				<div>
					<h3>Uploaded PDF</h3>
					<iframe
						src={pdfPreview}
						style={{ width: "100%", height: "500px" }}
					></iframe>
				</div>
			) : fileType === "audio" && audioPreview ? (
				<div>
					<h3>Uploaded Audio</h3>
					<audio
						controls
						src={audioPreview}
						style={{ width: "100%" }}
					></audio>
				</div>
			) : (
				<>
					<Typography margin={"10px 0px"} component={"p"}>
						Upload Master File
					</Typography>
					<Button
						component="label"
						role={undefined}
						variant="contained"
						tabIndex={-1}
						sx={{ width: "100%", padding: "10px" }}
						startIcon={<UploadFileIcon />}
					>
						Upload file
						<VisuallyHiddenInput
							onChange={handleContentFileChange}
							type="file"
							name="master"
							accept={
								formik.values.type === "WATCH"
									? ".mp4, .mpeg"
									: formik.values.type === "LISTEN"
									? ".mp3"
									: formik.values.type === "DEVOTION"
									? ".mp4, .mpeg, .pdf, .mp3"
									: ".pdf"
							}
						/>
					</Button>
					<Typography fontSize={12} sx={{ color: "grey" }}>
						Select a valid file type:{" "}
						{formik.values.type === "WATCH"
							? "Video files (.mp4, .mpeg)"
							: formik.values.type === "LISTEN"
							? "Audio files (.mp3)"
							: formik.values.type === "DEVOTION"
							? ".mp4, .mpeg, .pdf, .mp3"
							: "PDF files (.pdf)"}
					</Typography>
				</>
			)}
		</Box>
	);
};

export default MasterFileUpload;
